import cn from 'classnames'
import { FC } from 'react'
import { DotProps } from 'react-multi-carousel'
import s from './carousel.module.css'

const Dot: FC<DotProps> = ({ active, onClick }) => {
  return <button type="button" className={cn(s.dot, active && s.dotActive)} onClick={onClick} />
}

export { Dot }
